
/*
  CAR MAT 29
  BASE DE DATOS DE VEHÍCULOS
  Compatible con el cotizador Shopify.
*/

window.IG507VehicleDB = (() => {
  'use strict';

  let loaded = false;
  let loadingPromise = null;

  const database = {};
  const normalizedBrands = {};
  const modelIndex = [];
  const aliasIndex = [];

  function normalize(text) {
    return String(text || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function parseCSV(text) {
    const rows = [];
    let row = [];
    let field = '';
    let quoted = false;

    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      const next = text[i + 1];

      if (quoted) {
        if (char === '"' && next === '"') {
          field += '"';
          i++;
        } else if (char === '"') {
          quoted = false;
        } else {
          field += char;
        }
        continue;
      }

      if (char === ',') {
        row.push(field);
        field = '';
        continue;
      }

      if (char === '\n') {
        row.push(field);

        if (row.some(value =>
          String(value).trim() !== ''
        )) {
          rows.push(row);
        }

        row = [];
        field = '';
        continue;
      }

      if (char !== '\r') {
        field += char;
      }
    }

    if (field.length || row.length) {
      row.push(field);

      if (row.some(value =>
        String(value).trim() !== ''
      )) {
        rows.push(row);
      }
    }

    return rows;
  }

  function buildDatabase(csvText) {
    const rows = parseCSV(csvText);

    if (!rows.length) {
      throw new Error('vehicles.csv está vacío.');
    }

    const headers = rows.shift().map(item =>
      String(item || '').trim().toLowerCase()
    );

    const kindIndex = headers.indexOf('kind');
    const makeIndex = headers.indexOf('make_name');
    const modelColumn = headers.indexOf('model_name');
    const aliasesIndex = headers.indexOf('aliases');

    if (makeIndex === -1 || modelColumn === -1) {
      throw new Error(
        'El CSV debe contener make_name y model_name.'
      );
    }

    const temporary = {};

    rows.forEach(row => {
      const kind = kindIndex >= 0
        ? String(row[kindIndex] || '')
            .trim()
            .toLowerCase()
        : 'car';

      if (kind !== 'car') return;

      const brand = String(
        row[makeIndex] || ''
      ).trim();

      const model = String(
        row[modelColumn] || ''
      ).trim();

      if (!brand || !model) return;

      if (!temporary[brand]) {
        temporary[brand] = new Set();
      }

      temporary[brand].add(model);

      modelIndex.push({
        brand,
        model,
        brandNormalized: normalize(brand),
        modelNormalized: normalize(model),
        fullNormalized: normalize(
          `${brand} ${model}`
        )
      });

      if (aliasesIndex >= 0) {
        const aliases = String(
          row[aliasesIndex] || ''
        )
          .split('|')
          .map(item => item.trim())
          .filter(Boolean);

        aliases.forEach(alias => {
          aliasIndex.push({
            brand,
            model,
            alias,
            normalized: normalize(alias)
          });
        });
      }
    });

    Object.keys(temporary)
      .sort((a, b) =>
        a.localeCompare(b, 'es', {
          sensitivity: 'base',
          numeric: true
        })
      )
      .forEach(brand => {
        database[brand] = Array.from(
          temporary[brand]
        ).sort((a, b) =>
          a.localeCompare(b, 'es', {
            sensitivity: 'base',
            numeric: true
          })
        );

        normalizedBrands[normalize(brand)] =
          brand;
      });

    loaded = true;
    window.IG507_VEHICLES = database;

    console.log(
      `CAR MAT 29: ${
        Object.keys(database).length
      } marcas y ${
        modelIndex.length
      } modelos cargados`
    );

    return database;
  }

  async function load(csvUrl) {
    if (loaded) {
      return database;
    }

    if (loadingPromise) {
      return loadingPromise;
    }

    if (!csvUrl) {
      throw new Error(
        'Falta la URL de vehicles.csv.'
      );
    }

    loadingPromise = fetch(csvUrl, {
      cache: 'force-cache'
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(
            `Error cargando CSV: ${response.status}`
          );
        }

        return response.text();
      })
      .then(buildDatabase)
      .catch(error => {
        loadingPromise = null;

        console.error(
          'Error en base CAR MAT 29:',
          error
        );

        throw error;
      });

    return loadingPromise;
  }

  function getBrands() {
    return Object.keys(database);
  }

  function getModels(brand) {
    if (!brand) return [];

    if (database[brand]) {
      return database[brand];
    }

    const realBrand =
      normalizedBrands[normalize(brand)];

    return realBrand
      ? database[realBrand]
      : [];
  }

  function hasBrand(brand) {
    return Boolean(
      normalizedBrands[normalize(brand)]
    );
  }

  function hasModel(brand, model) {
    const models = getModels(brand);
    const wanted = normalize(model);

    return models.some(
      item => normalize(item) === wanted
    );
  }

  function resolveBrand(text) {
    return (
      normalizedBrands[normalize(text)] ||
      null
    );
  }

  function stats() {
    return {
      loaded,
      brands: Object.keys(database).length,
      models: modelIndex.length,
      aliases: aliasIndex.length
    };
  }

  return {
    load,
    normalize,
    getBrands,
    getModels,
    hasBrand,
    hasModel,
    resolveBrand,
    stats,

    get database() {
      return database;
    },

    get modelIndex() {
      return modelIndex;
    },

    get aliasIndex() {
      return aliasIndex;
    },

    get loaded() {
      return loaded;
    }
  };
})();
